import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { AuthGuard } from './auth.guard';
import { HomeComponent } from './home/home.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { authInterceptor } from './services/auth.interceptor';
import { UsersComponent } from './users/users.component';
import { AdminGuard } from './admin.guard';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter([
      { path: '', component: HomeComponent, canActivate: [AuthGuard] },
      { path: 'admin', loadChildren: () => import('./admin/core/admin.routes').then(m => m.routes), canActivate: [AuthGuard] },
      { path: 'users', component: UsersComponent, canActivate: [AdminGuard] },
      { path: 'login', loadComponent: () => import('./login/login.component').then(m => m.LoginComponent) },
      { path: 'auth/callback', component: AuthCallbackComponent },
      { path: 'privacy-policy', component: PrivacyPolicyComponent }
    ]),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: 'none',
          cssLayer: false
        }
      },
      ripple: true,
      inputVariant: 'outlined'
    }),
    provideBrowserGlobalErrorListeners()
  ]
};
